 
    <div class="footer" [ngClass]="{'error': error, className: !error}">

    </div>
 
